<template>
    <div class="all">
        <div class="screen">
            <div class="item clearfix">
                <span class="name">类别</span>
                <div class="screen-list">
                    <div class="corm clearfix">
                        <span class="element" @click="choseType(0)" :class="{'curr':typeName == 0}">全部</span>   
                        <span class="element" v-for="(item,index) in hotTypeList" :key="index" @click="choseType(index)" :class="{'curr':typeName == index}">{{item}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="warp mt20 clearfix">
            <div class="warp-body">
                <div class="no-data pt30" v-if="nodata"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                <ul class="event event-list clearfix">
                     <li v-for="(item,index) in topicsList" :key="index">
                        <router-link class="in" :to="{path:''+$parent.baseUrl+'/specialDetail',query:{id:item.id,name:item.name}}">
                            <img class="img db" :src="[item.icon]" :onerror="defaultImg"/>
                            <span class="name ac db">{{item.name}}</span>
                        </router-link>
                    </li>
                </ul>
                 <div class="mt20 ac" v-if="isShowMore">
                    <a class="more color-8a8a99" href="javascript:void(0);" @click="showMore">点击加载更多</a>
                </div>
                 <div class="mt20 ac" v-if="isShowEnd">
                    <a class="more color-8a8a99" href="javascript:void(0);">数据已经全部加载完成啦~</a>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data() {
        return {
            hotTypeList:[],
            topicsList:[],
            typeName:0,
            pageCur:1,
            pageNum:15,
            dataCount:0,
            defaultImg:'this.src="'+this.$parent.baseUrl+'/static/images/default.png"',
            isShowMore:false,
            isShowEnd:false,
            nodata:false
        }
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            that.dataAjax();
            that.topicsListAjax(0);
        })
    },
    methods: {
        dataAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('hotnews/index/hot-topic-type',null,r=>{
                that.$parent.returnCode(r,function(){
                    that.hotTypeList = r.data;
                });
            });
        },
        topicsListAjax(type){
            let that = this;
            that.$api.get('hotnews/hot-topics/list',{type:that.typeName,perpage:that.pageNum,page:that.pageCur},r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    if(r.data.list.length<=0){
                        that.nodata = true;
                        return
                    }else{
                        that.nodata = false;
                    }
                    that.dataCount = r.data.count;
                    if(that.dataCount>that.pageNum*that.pageCur){
                        that.isShowMore = true;
                    }else{
                        that.isShowMore = false;
                        that.isShowEnd = true;
                    }
                    if(type==1){
                        that.topicsList = r.data.list;
                    }else{
                        that.topicsList = that.topicsList.concat(r.data.list);
                    }
                });
            });
        },
		choseType(type){
            let that = this;
            that.isShowMore = false;
            that.isShowEnd = false;
            that.pageCur=1;
            that.topicsList = [];
            that.typeName = type;
            that.topicsListAjax(1);
        },
        showMore(){
            let that = this;
            that.pageCur++;
            if(that.dataCount>((that.pageCur-1)*that.pageNum)){
                that.topicsListAjax(0);
            }
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/hotSpotEvents/specialKu.vue